import script from "./Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=542ec44b&scoped=true&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-542ec44b"]])

export default __exports__